import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_exception = _resolveComponent("exception")!

  return (_openBlock(), _createBlock(_component_exception, {
    title: "404 Error!",
    description: "抱歉，你访问的页面不存在~"
  }))
}